export default __webpack_public_path__ + "static/media/save.6c590fd8.svg";